import NormalFormFooter from 'components/FormFooter/NormalFormFooter'
import { CurrentFormikContext } from 'context'
import { Formik, FormikConfig } from 'formik'
import { invokeAll } from 'helpers'
import { IPanelProps, Panel, PanelType } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export type FormikPanelProps<TValues = any> = Omit<
  IPanelProps,
  'onRenderFooter' | 'onRenderFooterContent' | 'isFooterAtBottom' | 'onSubmit'
> &
  Pick<
    FormikConfig<TValues>,
    'initialValues' | 'validationSchema' | 'onSubmit' | 'onReset'
  > & { submitText?: string; enableSubmit?: boolean }

export const NormalPanel: React.FunctionComponent<FormikPanelProps<any>> = ({
  initialValues,
  validationSchema,
  onSubmit,
  onReset,
  onDismiss,
  children,
  submitText,
  enableSubmit,
  ...panelProps
}) => {
  const { t } = useTranslation()

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      onReset={onReset}
      render={(formikProps) => (
        <Panel
          type={PanelType.medium}
          closeButtonAriaLabel={t('action.close')}
          onDismiss={onDismiss}
          {...panelProps}
          onDismissed={() => formikProps.resetForm(initialValues || {})}
          onRenderFooterContent={() => (
            <NormalFormFooter
              onCancelClick={invokeAll<any>(
                formikProps.resetForm.bind(formikProps, undefined),
                onDismiss
              )}
            />
          )}
          isFooterAtBottom={true}
        >
          <CurrentFormikContext.Provider value={formikProps}>
            {panelProps.isOpen ? children : null}
          </CurrentFormikContext.Provider>
        </Panel>
      )}
    />
  )
}
